import React from "react";
import Navbar from "../LandingPage/Navbar/navbar";
import Footer from "../LandingPage/footer/footer";

export default function Layout({ children }) {
  return (
    <div>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
